import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../services/api";

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);

  /* ---------------- FETCH BLOGS ---------------- */
  useEffect(() => {
    api.get("/api/blogs")
      .then(res => {
        setBlogs(res.data || []);
      })
      .catch(err => console.error("Blog fetch error", err));
  }, []);

  if (!blogs.length) return null;

  const [featuredBlog, ...sideBlogs] = blogs;

  return (
    <section className="blog-overall-section py-5">
      <div className="container">

        {/* SECTION HEADER */}
        <div className="row mb-3 mb-md-5">
          <div className="col-12 text-center">
            <h2
              className="section-title"
              data-sal="slide-up"
              data-sal-duration="1000"
              data-sal-delay="100"
            >
              Lifeline Tulasi Blogs
            </h2>
            <p
              className="section-subtitle"
              data-sal="slide-up"
              data-sal-duration="1000"
              data-sal-delay="300"
            >
              Check out our latest scoops on healthcare
            </p>
          </div>
        </div>

        <div className="blog-section">

          {/* FEATURED BLOG */}
          <div className="featured-blog">
            <img
              data-sal="slide-up"
              data-sal-duration="300"
              src={`${process.env.REACT_APP_WEB_URL}${featuredBlog.main_image}`}
              alt={featuredBlog.title}
            />

            <div
              className="featured-overlay"
              data-sal="slide-up"
              data-sal-duration="300"
            >
              <div className="blog-left-content">
                <h2>{featuredBlog.title}</h2>
                <p>{featuredBlog.subtitle}</p>
                <span>{featuredBlog.author}</span>
              </div>

              <div className="d-flex align-items-end justify-content-center">
                <Link
                  to={`/blog-details/${featuredBlog.slug}`}
                  className="btn"
                >
                  CLICK HERE
                </Link>
              </div>
            </div>
          </div>

          {/* SIDE BLOGS Mobile */}
          <div className="d-md-none">
            {sideBlogs.slice(0, 3).map((blog, idx) => (
              <div className={`featured-blog ${idx === sideBlogs.length - 1 ? '' : 'mb-4'}`} key={idx}>
                <img
                  data-sal="slide-up"
                  data-sal-duration="300"
                  src={`${process.env.REACT_APP_WEB_URL}${blog.main_image}`}
                  alt={blog.title}
                />

                <div
                  className="featured-overlay"
                  data-sal="slide-up"
                  data-sal-duration="300"
                >
                  <div className="blog-left-content">
                    <h2>{blog.title}</h2>
                    <p>{blog.subtitle}</p>
                    <span>{blog.author}</span>
                  </div>

                  <div className="d-flex align-items-end justify-content-center">
                    <Link
                      to={`/blog-details/${blog.slug}`}
                      className="btn"
                    >
                      CLICK HERE
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* SIDE BLOGS Desktop */}
          <div className="side-blogs d-none d-md-block">
            {sideBlogs.slice(0, 3).map((blog, idx) => (
              <div
                className="side-blog"
                key={idx}
                data-sal="slide-up"
                data-sal-duration="300"
                data-sal-delay={(idx + 1) * 50}
              >
                <div className="side-blog-image-wrapper">
                  <img
                    src={`${process.env.REACT_APP_WEB_URL}${blog.main_image}`}
                    alt={blog.title}
                  />
                </div>

                <div className="side-blog-content">
                  <h3>
                    <Link to={`/blog-details/${blog.slug}`}>
                      {blog.title}
                      <br />
                      <span>{blog.subtitle}</span>
                    </Link>
                  </h3>

                  <div className="d-flex justify-content-between">
                    <span>
                      <i>{blog.author}</i>
                    </span>
                    <Link
                      to={`/blog-details/${blog.slug}`}
                      className="open-btn"
                    >
                      OPEN
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* READ MORE */}
        <div className="row">
          <div className="col-12 text-center mt-5">
            <Link
              to="/bloglist"
              className="about-btn"
              data-sal="slide-up"
              data-sal-duration="1000"
              data-sal-delay="100"
            >
              Read More Articles
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default BlogSection;
